var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#EEEEEE"}},[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-app-bar-title',[_vm._v("EUREC4A | Images Tool")])],1),_c('v-main',[_c('HelloWorld')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }